import { ThemeColors } from '~/themes/colors'

export interface CloseButtonColors {
  Primary: {
    Background: {
      Default: ThemeColors
      Hover: ThemeColors
      Active: ThemeColors
    }
    Icon: ThemeColors
  }
  AlertWindow: {
    Background: {
      Default: ThemeColors
      Hover: ThemeColors
      Active: ThemeColors
    }
    Icon: ThemeColors
  }
}

export const closeButtonColors: CloseButtonColors = {
  Primary: {
    Background: {
      Default: {
        default: 'achromatic.transparent',
      },
      Hover: {
        default: 'gray.400',
      },
      Active: {
        default: 'gray.500',
      },
    },
    Icon: {
      default: 'gray.1300',
    },
  },
  AlertWindow: {
    Background: {
      Default: {
        default: 'achromatic.transparent',
      },
      Hover: {
        default: 'mask.white.20',
      },
      Active: {
        default: 'mask.white.40',
      },
    },
    Icon: {
      default: 'white',
    },
  },
}
